// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1myAJ","top":"styles_top__2vUUH","left":"styles_left__2loPP","description":"styles_description__2j7dp"};